import React from 'react';
import styled, { css } from 'styled-components';
import { useLink } from '@react-aria/link';

import { sitekitTokens } from '../../../../../../tokens/components/SiteKit/tokens';
import { buttonTokens } from '../../../../../../tokens/components/Button/tokens';

import CustomText from '../../../../../Typography/CustomText/CustomText';

// Fragments
const SiteKitUtilityAnchorWrapper = styled.a`
  color: inherit;
  cursor: pointer;
  text-align: start;
  border: 1px solid transparent;
  background: transparent;
  margin: 0 -8px;
  padding: 12px 8px;
  border-radius: 8px;
  &:hover {
    background: ${sitekitTokens.CoreUtilityBackgroundColorHover};
    text-decoration: none;
  }

  &:focus {
    box-shadow: ${buttonTokens.ShadowSecondaryKeyboardFocus};
  }

  &:focus:not(:focus-visible) {
    box-shadow: none;
  }

  &:focus-visible {
    box-shadow: none;
    outline: ${buttonTokens.OutlineStrokeSecondaryKeyboardFocus} ${buttonTokens.OutlineColorSecondaryKeyboardFocus};
    outline-offset: ${buttonTokens.OutlineOffsetSecondaryDefault};
  }

  &:active {
    background-color: ${sitekitTokens.CoreUtilityBackgroundColorActive};
  }

  ${({ theme }) =>
    theme.active &&
    css`
      background: ${sitekitTokens.CoreUtilityBackgroundColorSelected};
    `}
`;

// Exports
interface SiteKitUtilityAnchorProps extends React.AnchorHTMLAttributes<Element> {
  active?: boolean;
}
const SiteKitUtilityAnchor = (props: SiteKitUtilityAnchorProps) => {
  const { active = false, children, ...otherProps } = props;

  // This is a false positive, evaluated by Rodrigo
  // eslint-disable-next-line ssr-friendly/no-dom-globals-in-react-fc
  const ref = React.useRef() as React.MutableRefObject<HTMLAnchorElement | null>;
  const { linkProps } = useLink({ ...props, elementType: 'a' }, ref);

  return (
    <SiteKitUtilityAnchorWrapper {...linkProps} {...otherProps} theme={{ active }}>
      <CustomText size="14">{children}</CustomText>
    </SiteKitUtilityAnchorWrapper>
  );
};

SiteKitUtilityAnchor.displayName = 'SiteKit.Sidebar.Utilities.Anchor';

export { SiteKitUtilityAnchor, SiteKitUtilityAnchorProps };
